import cn from 'classnames';
import { ReactElement, ReactNode } from 'react';

import type { Spacing } from '@/ui/types';

import s from './Field.module.css';

export type FieldProps = {
  children: ReactNode;
  className?: string | undefined;
  spacing?: Spacing;
};

const Field = ({ children, className, spacing }: FieldProps): ReactElement => (
  <div className={cn(s.field, className, { [`spacing-${spacing}`]: !!spacing })}>{children}</div>
);

export default Field;
